import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStreetView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_457_1240)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 0C8.53043 0 9.03914 0.210714 9.41421 0.585786C9.78929 0.960859 10 1.46957 10 2C10 2.53043 9.78929 3.03914 9.41421 3.41421C9.03914 3.78929 8.53043 4 8 4C7.46957 4 6.96086 3.78929 6.58579 3.41421C6.21071 3.03914 6 2.53043 6 2C6 1.46957 6.21071 0.960859 6.58579 0.585786C6.96086 0.210714 7.46957 0 8 0ZM7 5H9C10.1031 5 11 5.89688 11 7V8.5C11 9.05313 10.5531 9.5 10 9.5H9.94375L9.59688 12.6094C9.54063 13.1156 9.1125 13.5 8.60312 13.5H7.39375C6.88438 13.5 6.45625 13.1156 6.4 12.6094L6.05312 9.5H5.99687C5.44375 9.5 4.99687 9.05313 4.99687 8.5V7C4.99687 5.89688 5.89375 5 6.99687 5H7ZM12.8875 12.5063C12.3844 12.375 11.8 12.2687 11.1562 12.1875L11.3219 10.6969C12.0312 10.7875 12.6875 10.9062 13.2625 11.0562C13.9625 11.2375 14.5938 11.4719 15.0688 11.7844C15.5281 12.0844 16 12.5625 16 13.2531C16 13.9438 15.5281 14.4219 15.0688 14.7219C14.5938 15.0313 13.9594 15.2687 13.2625 15.45C11.8531 15.8156 9.97187 16.0063 8 16.0063C6.02813 16.0063 4.14687 15.8156 2.7375 15.45C2.0375 15.2625 1.40625 15.0281 0.93125 14.7188C0.471875 14.4187 0 13.9406 0 13.25C0 12.5594 0.471875 12.0813 0.93125 11.7812C1.40625 11.4719 2.04062 11.2344 2.7375 11.0531C3.31562 10.9031 3.97187 10.7844 4.67812 10.6938L4.84375 12.1875C4.2 12.2687 3.61562 12.3781 3.1125 12.5063C1.34375 12.9625 1.34375 13.5344 3.1125 13.9906C4.35938 14.3125 6.10625 14.4969 8 14.4969C9.89375 14.4969 11.6406 14.3125 12.8875 13.9906C14.6562 13.5344 14.6562 12.9625 12.8875 12.5063Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_457_1240",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgStreetView;
